import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { AuthModalService } from '../../services/auth-modal.service';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SlidingGalleryComponent } from '../../components/sliding-gallery/sliding-gallery.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'eng-home',
  imports: [SlidingGalleryComponent],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  private readonly authModalService = inject(AuthModalService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  public isAuthenticated = false;
  private authSubscription?: Subscription;

  ngOnInit(): void {
    // Subscribe to authentication status from AuthService
    this.authSubscription = this.authService.getAuthenticationStatus().subscribe(isAuthenticated => {
      this.isAuthenticated = isAuthenticated;

      if (isAuthenticated) {
        this.onGetStarted();
      }
    });

    this.route.queryParams.subscribe(params => {
      if (params['showLogin'] === 'true' && !this.isAuthenticated) {
        // Small delay to ensure the component is fully initialized
        setTimeout(() => {
          this.authModalService.openLoginModal('');
        }, 100);
      }

      if (params['showRegister'] === 'true' && !this.isAuthenticated) {
        // Small delay to ensure the component is fully initialized
        setTimeout(() => {
          this.authModalService.openRegisterModal('');
        }, 100);
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  onGetStarted(): void {
    if (this.isAuthenticated) {
      // Check if we should go to prototype or projects
      this.route.queryParams
        .subscribe(params => {
          if (params['prototype'] === 'true') {
            this.router.navigate(['/prototype']);
          } else {
            this.router.navigate(['/projects']);
          }
        })
        .unsubscribe();
    } else {
      // Open register modal
      this.authModalService.openLoginModal('');
    }
  }
}
